/*
 * @Author: your name
 * @Date: 2022-03-01 15:08:19
 * @LastEditTime: 2022-03-08 09:51:37
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /demander-manage/src/api/user.js
 */
import request from '@/utils/request'

// 登录方法
export function login(data) {
  return request({
    url: 'mall/user/login',
    method: 'post',
    data: data
  })
}
export function cityArea(params) {
  return request({
    url: '/mall/archives/unit/area/1',
    method: 'post',
    params: params
  })
}

export function register(data) {
  return request({
    url: '/mall/user/register',
    method: 'post',
    data: data
  })
}
export function modification(data) {
  return request({
    url: '/mall/user/modification',
    method: 'post',
    data: data
  })
}
export function upPassword(data) {
  return request({
    url: '/mall/user/upPassword',
    method: 'post',
    data: data
  })
}

export function getInfo(data) {
  return request({
    url: '/mall/user/getuserInfo',
    method: 'post',
    data: data
  })
}

export function logout() {
  return request({
    url: '/vue-admin-template/user/logout',
    method: 'post'
  })
}

export function queryArea(params) {
  return request({
    url: '/mall/ordermanage/useraddress/queryArea',
    method: 'post',
    params
  })
}

export function uploadImg(data) {
  return request({
    url: '/mall/uploadImg',
    method: 'post',
    data
  })
}

export function sendMsg(params) {
  return request({
    url: '/mall/ordermanage/useraddress/sendMsg',
    method: 'post',
    params
  })
}

export function getDocList() {
  return request({
    url: '/mall/mallmanage/index/getDocList',
    method: 'post'
  })
}

export function getRigistDocTitList(params) {
  return request({
    url: '/mall/ordermanage/platformdoc/getRigistDocTitList',
    method: 'post',
    params
  })
}
